import { useRouter } from "next/router";

export function getLocale(path: string) {
  if (!path) {
    return {};
  }
  const [locale] = path.replace(/^\/+|[?#].*$/g, "").split("/");
  return locale?.length === 2 ? { locale } : {}; // No collisions with slugs, as slugs should have at least 3 chars: seller + "-" + listing
}

export function prependLocaleToPath(dest: string, locale?: string) {
  const { locale: destLocale } = getLocale(dest);
  if (!locale || destLocale) {
    return dest;
  }
  return locale + dest;
}

export function useLocale() {
  const router = useRouter();
  return getLocale(router.asPath);
}
